import { ShortlistPlayersTable } from '@statsbomb/kitbag-shortlists';
import { useAtomValue } from 'jotai';
import { useTranslation } from 'react-i18next';
import { useParams } from 'react-router-dom';
import { unwrappedPlayerIdMappingAtom } from '@/atoms/queries/players';
import { userNavOverridesAtom } from '@/atoms/queries/user';
import { TEMPORARY_FILTER_SET_ID } from '@/consts/filters/filterSets';
import { useNavigateToFilterSetId } from '@/hooks/useNavigateToFilterSetId';
import { classicEntityDashboardUrl } from '@/utils/classicLinks';
import { createTempFilterSet } from '@/utils/filters';

export const RecruitmentListPlayers = () => {
  const { recruitmentListId } = useParams();
  const isPlayerClassicXp = useAtomValue(userNavOverridesAtom).player;
  const playersMapping = useAtomValue(unwrappedPlayerIdMappingAtom);

  const {
    i18n: { language: locale },
  } = useTranslation();
  const navigateToFilterSetId = useNavigateToFilterSetId(`/${locale}/data-locker/players`);

  const handleClick = (playerId: number) => {
    const newXpUrl = `/${locale}/player/${playerId}/dashboard`;
    // A player without a Classic id opens in the new experience rather than a broken Classic URL.
    const classicPlayerHref = isPlayerClassicXp
      ? classicEntityDashboardUrl('player', playersMapping[Number(playerId)])
      : undefined;
    const url = classicPlayerHref ?? newXpUrl;
    window.open(url, '_blank', 'noopener,noreferrer');
  };

  return (
    <div className="p-2 h-full">
      <ShortlistPlayersTable
        shortlistId={recruitmentListId || ''}
        onOpenInPlayerScout={async playerIds => {
          try {
            /* we pass back strings but parachute atom requires numbers */
            await createTempFilterSet({ playerIds: playerIds.map(id => Number(id)) });
            await navigateToFilterSetId(TEMPORARY_FILTER_SET_ID);
          } catch (error) {
            // eslint-disable-next-line no-console
            console.error('Failed to open players in Player Scout:', error);
          }
        }}
        onLinkClick={handleClick}
      />
    </div>
  );
};
